/**
 * Promo Banner Service — API calls for banner delivery, tracking, and admin management
 */
import api from './api';

const promoBannerService = {
  // ── Public / User ──
  getActive: (placement) => api.get('/promo-banners/active', { params: { placement } }).then(r => r.data),
  track: (bannerId, eventType, page) => api.post('/promo-banners/track', { bannerId, eventType, page }).then(r => r.data),

  // ── Admin ──
  adminList: (params) => api.get('/promo-banners/admin', { params }).then(r => r.data),
  adminGet: (id) => api.get(`/promo-banners/admin/${id}`).then(r => r.data),
  adminCreate: (data) => api.post('/promo-banners/admin', data).then(r => r.data),
  adminUpdate: (id, data) => api.put(`/promo-banners/admin/${id}`, data).then(r => r.data),
  adminSetStatus: (id, status) => api.patch(`/promo-banners/admin/${id}/status`, { status }).then(r => r.data),
  adminDelete: (id) => api.delete(`/promo-banners/admin/${id}`).then(r => r.data),
  adminDuplicate: (id) => api.post(`/promo-banners/admin/${id}/duplicate`).then(r => r.data),
  adminStats: () => api.get('/promo-banners/admin/stats').then(r => r.data),
  adminAnalytics: (id) => api.get(`/promo-banners/admin/${id}/analytics`).then(r => r.data),
};

export default promoBannerService;
